
export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    default: {
      type: String,
      required: false,
      default: null
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    id: {
      type: String,
      required: false
    },
    setGetFromChoosed: {
      type: Function,
      required: false
    },
    error: {
      type: Boolean,
      required: false
    },
    errorText: {
      type: String,
      required: false
    },
    control_key: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      selected: this.default ? this.default : this.options[0],
      open: false,
      idx: 0
    }
  },
  mounted() {
    this.$emit('input', this.selected)
  }
}
